module.exports = __webpack_public_path__ + "ea941ef5d63c1e7e3401344759d42c25.png";